var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FF9605"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.856 12.2646L20.9455 9.04883H11.0175L9.11068 12.2646H9.07422V13.3985C9.08943 13.8134 9.26823 14.2054 9.57155 14.4889C9.87486 14.7724 10.2781 14.9244 10.693 14.9116H10.941C11.3559 14.9244 11.7591 14.7724 12.0625 14.4889C12.3658 14.2054 12.5446 13.8134 12.5598 13.3985C12.5741 13.8131 12.7521 14.2051 13.0548 14.4887C13.3575 14.7723 13.7603 14.9243 14.1749 14.9116H14.4265C15.1885 14.9116 15.8266 14.0475 15.9943 13.3803C16.162 14.0475 16.8001 14.9116 17.5657 14.9116H17.8246C18.2396 14.9244 18.6428 14.7724 18.9461 14.4889C19.2494 14.2054 19.4282 13.8134 19.4434 13.3985C19.4577 13.8131 19.6357 14.2051 19.9384 14.4887C20.2412 14.7723 20.6439 14.9243 21.0586 14.9116H21.3065C21.7215 14.9244 22.1247 14.7724 22.428 14.4889C22.7313 14.2054 22.9101 13.8134 22.9253 13.3985V12.2646H22.856Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.929 20.1152H9.07422V22.6674H22.929V20.1152Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4688 15.0098V20.1141",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5312 15.0098V20.1141",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/storeIcon.20e5a9502c6b821c4c31cac917e4d748.svg";
export { ForwardRef as ReactComponent };